import { disableAllVideoTracks, enableAllVideoTracks } from "@kalyzee/kast-web-sdk/web-components";
import { OvenMediaReceiverWebRTCSession, OvenMediaWebRTCSessionResponse } from "@kalyzee/kast-web-sdk/webrtc";

export abstract class OvenMediaSessionService {

  static async enableVideo(
    session: OvenMediaReceiverWebRTCSession,
    callback?: (success: boolean, response?: OvenMediaWebRTCSessionResponse<{video: boolean, audio: boolean}>) => void
  ): Promise<boolean> {
    if (session.stream) enableAllVideoTracks(session.stream);
    const response = await session.enableTracks(true, undefined);
    callback?.(true, response);
    return true;
  }

  static async disableVideo(
    session: OvenMediaReceiverWebRTCSession,
    callback?: (success: boolean, response?: OvenMediaWebRTCSessionResponse<{video: boolean, audio: boolean}>) => void
  ): Promise<boolean> {
    if (session.stream) disableAllVideoTracks(session.stream);
    const response = await session.enableTracks(false, undefined);
    callback?.(true, response);
    return true;
  }

  static videoIsEnabled(session: OvenMediaReceiverWebRTCSession): boolean {
    return session.videoIsEnabled;
  }
}
